/**
 * EMBER PARFUM — Theme JavaScript
 * Shopify theme asset: assets/ember.js
 * ─────────────────────────────────────
 * 1. Shopify AJAX Cart
 * 2. Cart Drawer
 * 3. Menu Overlay
 * 4. Cinematic Scroll (IntersectionObserver + RAF parallax)
 * 5. Legal Modals (Privacy · Terms · Shipping — Bahrain PDPL compliant)
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════════════
     1. SHOPIFY AJAX CART
  ════════════════════════════════════════════════════ */

  var CartAPI = {

    getCart: function (cb) {
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { cb(data); })
        .catch(function (e) { console.error('Cart fetch error:', e); });
    },

    addItem: function (variantId, quantity, cb) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { cb(null, data); })
        .catch(function (e) { cb(e); });
    },

    removeItem: function (key, cb) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { cb(null, data); })
        .catch(function (e) { cb(e); });
    },

    changeQuantity: function (key, quantity, cb) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { cb(null, data); })
        .catch(function (e) { cb(e); });
    }
  };

  /* Format money (Shopify returns cents) */
  function formatMoney(cents) {
    /* Use Shopify's own currency symbol and format */
    var amount = (cents / 100);
    /* Remove trailing .00 or .000 */
    var formatted = amount % 1 === 0 ? amount.toFixed(0) : amount.toString();
    var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active + ' '
      : (window.theme_currency ? window.theme_currency + ' ' : 'BD ');
    return symbol + formatted;
  }

  /* ════════════════════════════════════════════════════
     2. CART DRAWER
  ════════════════════════════════════════════════════ */

  function openCart() {
    var drawer = document.getElementById('cartDrawer');
    var veil   = document.getElementById('cartVeil');
    if (!drawer || !veil) return;
    drawer.classList.add('open');
    veil.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCartDrawer();
  }

  function closeCart() {
    var drawer = document.getElementById('cartDrawer');
    var veil   = document.getElementById('cartVeil');
    if (!drawer || !veil) return;
    drawer.classList.remove('open');
    veil.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function refreshCartDrawer() {
    CartAPI.getCart(function (cart) {
      renderCartDrawer(cart);
    });
  }

function renderCartDrawer(cart) {
    var ctEl    = document.getElementById('cartCt');
    var totalEl = document.getElementById('cartTotal');
    var itemsEl = document.getElementById('cartItems');

    if (ctEl)    ctEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty-msg">YOUR BAG IS EMPTY</div>';
      return;
    }

    var rowsHtml = cart.items.map(function (item) {
      return '<div class="cart-row" data-key="' + item.key + '">' +
        '<div>' +
          '<div class="name serif">' + item.product_title + '</div>' +
          '<div class="sub">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '') + 'Qty: ' + item.quantity + '</div>' +
        '</div>' +
        '<div class="rhs">' +
          '<span class="pr serif">' + formatMoney(item.final_line_price) + '</span>' +
          '<button class="rm js-remove-item" data-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">×</button>' +
        '</div>' +
        '</div>';
    }).join('');

    /* Trilogy nudge: show if 2+ of the 3 individual fragrances are in cart, and Trilogy itself isn't */
    var FRAGRANCE_HANDLES = ['anbar', 'oud', 'bakhoor'];
    var handlesInCart = cart.items.map(function (item) { return item.handle; });
    var fragranceCount = FRAGRANCE_HANDLES.filter(function (h) { return handlesInCart.indexOf(h) !== -1; }).length;
    var hasTrilogy = handlesInCart.indexOf('the-trilogy') !== -1;

    if (fragranceCount >= 2 && !hasTrilogy) {
      rowsHtml += '<a href="/products/the-trilogy" class="cart-trilogy-nudge">' +
        '<span class="cart-trilogy-label">BUY ALL THREE &middot; SAVE 10%</span>' +
        '<span class="cart-trilogy-cta">SHOP THE TRILOGY &rarr;</span>' +
        '</a>';
    }

    itemsEl.innerHTML = rowsHtml;

    /* Bind remove buttons */
    itemsEl.querySelectorAll('.js-remove-item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        CartAPI.removeItem(btn.dataset.key, function (err, cart) {
          if (!err) renderCartDrawer(cart);
        });
      });
    });
  }

  /* Add to Cart buttons — [data-variant-id] */
  function bindAddToCartButtons() {
    document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;
        btn.disabled = true;
        btn.textContent = 'ADDING…';
        CartAPI.addItem(variantId, 1, function (err, item) {
          btn.disabled = false;
          btn.textContent = 'ADD TO BAG →';
          if (err) {
            console.error('Add to cart error:', err);
            return;
          }
          refreshCartDrawer();
          openCart();
        });
      });
    });
  }

  /* Cart page quantity buttons */
  function bindCartPageQty() {
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var key    = btn.dataset.key;
        var change = parseInt(btn.dataset.change, 10);

        /* Always re-fetch the live cart first — never trust on-screen text or a cached key */
        document.querySelectorAll('.qty-btn').forEach(function (b) { b.disabled = true; });

        CartAPI.getCart(function (cart) {
          var line = cart.items.filter(function (item) { return item.key === key; })[0];
          if (!line) {
            /* Key is stale — force a full reload to resync DOM with real cart state */
            window.location.reload();
            return;
          }
          var newQty = Math.max(0, line.quantity + change);
          CartAPI.changeQuantity(key, newQty, function (err) {
            if (!err) window.location.reload();
          });
        });
      });
    });
  }

  /* ════════════════════════════════════════════════════
     3. MENU OVERLAY
  ════════════════════════════════════════════════════ */

  function openMenu() {
    var menu = document.getElementById('menu');
    if (!menu) return;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    var menu = document.getElementById('menu');
    if (!menu) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ════════════════════════════════════════════════════
     4. CINEMATIC SCROLL ENGINE
  ════════════════════════════════════════════════════ */

  var RAF     = window.requestAnimationFrame || function (fn) { setTimeout(fn, 16); };
  var ticking = false;
  var scrollY = 0;
  var vh      = window.innerHeight;

  /* ── IntersectionObserver reveals ── */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

  function initReveal() {
    var selectors = [
      '[data-reveal]', '[data-reveal-up]', '[data-reveal-img]',
      '.reveal-lines', '.trio-card', '.note', '.fr-buy',
      '.rail:not(.hero-rail)', '.hero-title', '.hero-ar',
      '.hero-eyebrow', '.hero-sub', '.hero-actions', '.hero-bottle'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Parallax layers ── */
  var parallaxLayers = [];

  function buildParallax() {
    var heroBg = document.querySelector('.hero-bg img');
    if (heroBg) parallaxLayers.push({ el: heroBg, speed: 0.25 });
    document.querySelectorAll('.fr-visual-img').forEach(function (img) {
      parallaxLayers.push({ el: img, speed: 0.18 });
    });
    var atmImg = document.querySelector('.atm-img');
    if (atmImg) parallaxLayers.push({ el: atmImg, speed: 0.22 });
    var setBg = document.querySelector('.set-bg-img');
    if (setBg) parallaxLayers.push({ el: setBg, speed: 0.15 });
  }

  function tickParallax() {
    parallaxLayers.forEach(function (layer) {
      var rect = layer.el.parentElement.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;
      var offset = (rect.top + rect.height / 2 - vh / 2) * layer.speed;
      layer.el.style.transform = 'translateY(' + offset + 'px) scale(1.12)';
    });
  }

  /* ── Chapter pill ── */
  var chapterSections = [];
  var chapterPill = document.getElementById('chapterPill');
  var chapterNum  = document.getElementById('chapterNum');
  var chapterTtl  = document.getElementById('chapterTtl');
  var pillTimer;

  function buildChapters() {
    chapterSections = Array.from(document.querySelectorAll('[data-chapter]')).map(function (el) {
      return { el: el, num: el.dataset.chapter, name: el.dataset.chapterName };
    });
  }

  function tickUI() {
    document.getElementById('nav') && document.getElementById('nav').classList.toggle('scrolled', scrollY > 50);
    var mid = scrollY + vh / 2;
    var active = chapterSections[0];
    chapterSections.forEach(function (s) {
      if (s.el.offsetTop <= mid) active = s;
    });
    if (active && chapterNum && chapterNum.textContent !== active.num) {
      chapterNum.textContent = active.num;
      chapterTtl.textContent = active.name;
      chapterPill && chapterPill.classList.add('visible');
      clearTimeout(pillTimer);
      pillTimer = setTimeout(function () {
        chapterPill && chapterPill.classList.remove('visible');
      }, 2000);
    }
  }

  /* ── Hero bottle drift on scroll ── */
  var heroBottles = [];

  function buildHeroBottles() {
    heroBottles = Array.from(document.querySelectorAll('.hero-bottle img'));
  }

  function tickHeroBottles() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > vh) return;
    var progress = Math.max(0, Math.min(1, -rect.top / rect.height));
    heroBottles.forEach(function (img, i) {
      var drift = progress * (60 + i * 18);
      var scale = Math.max(0.88, 1 - progress * (0.04 + i * 0.01));
      img.style.transform = 'translateY(' + drift + 'px) scale(' + scale + ')';
    });
  }

  /* ── Veil depth ── */
  var sectionVeils = [];
  function tickVeils() {
    sectionVeils.forEach(function (veil) {
      var rect = veil.parentElement.getBoundingClientRect();
      var progress = Math.max(0, Math.min(1, 1 - rect.top / vh));
      var base = veil.classList.contains('atm-veil') ? 0.62 : 0.3;
      veil.style.opacity = Math.min(0.95, base + progress * 0.15);
    });
  }

  /* ── Stagger fr-copy children ── */
  function staggerCopyChildren() {
    document.querySelectorAll('.fr-copy').forEach(function (copy) {
      copy.querySelectorAll('.fr-ew, .fr-nm, .fr-ar-name, .fr-lede').forEach(function (child, i) {
        child.setAttribute('data-reveal', '');
        child.setAttribute('data-delay', String(i + 1));
      });
    });
    ['.set-title', '.set-lede', '.set-buy',
     '.mani-quote', '.mani-split p', '.mani-num',
     '.wl-title', '.wl-sub', '.wl-form',
     '.atm-ar', '.atm-title', '.atm-mark'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, i) {
        el.setAttribute('data-reveal', '');
        el.setAttribute('data-delay', String(i + 1));
      });
    });
    document.querySelectorAll('.trio-title').forEach(function (el) {
      el.setAttribute('data-reveal-up', '');
    });
    document.querySelectorAll('.fr-visual-img, .incense-img').forEach(function (el) {
      el.setAttribute('data-reveal-img', '');
    });
  }

  /* ── Main RAF loop ── */
  function onTick() {
    tickParallax();
    tickUI();
    tickHeroBottles();
    tickVeils();
    ticking = false;
  }

  /* ════════════════════════════════════════════════════
     5. LEGAL MODALS — Bahrain PDPL compliant
  ════════════════════════════════════════════════════ */

  var LEGAL = {

    privacy: {
      eyebrow: 'EMBER · PRIVACY POLICY',
      title: 'Privacy Policy',
      html: '<span class="legal-ref">IN ACCORDANCE WITH PDPL LAW NO. 30 OF 2018 · KINGDOM OF BAHRAIN</span>' +
        '<p>Quorum Consultancy W.L.L, trading as Ember Parlum ("<strong>Ember</strong>", "we", "us") is committed to protecting your personal data in accordance with the Personal Data Protection Law No. 30 of 2018 (PDPL) of the Kingdom of Bahrain, as supplemented by the Ministerial Resolutions issued by the Personal Data Protection Authority (PDPA) on 17 March 2022.</p>' +
        '<p>This Privacy Policy explains what data we collect, how we use it, your rights as a data subject, and how to contact us. By using our website and placing orders, you agree to the terms of this Policy.</p>' +

        '<h3>1. Data Controller</h3>' +
        '<p>Ember Parfum, registered in the Kingdom of Bahrain under Commercial Registration No. 197815-1, registered address: Al Hidd, Manama, Kingdom of Bahrain. Contact: <strong>support@emberparlum.com</strong></p>' +

        '<h3>2. Data We Collect</h3>' +
        '<span class="legal-ref">PDPL ART. 4 — LAWFUL BASIS OF PROCESSING</span>' +
        '<ul>' +
        '<li><strong>Identity data:</strong> Full name</li>' +
        '<li><strong>Contact data:</strong> Email address, phone number, delivery address</li>' +
        '<li><strong>Transaction data:</strong> Order details, purchase history, payment confirmation references</li>' +
        '<li><strong>Technical data:</strong> IP address, browser type, device identifiers, pages visited</li>' +
        '<li><strong>Marketing data:</strong> Communication preferences (only with explicit consent)</li>' +
        '</ul>' +
        '<p>We do <strong>not</strong> store payment card data. All payment processing is handled by PCI-DSS compliant processors.</p>' +

        '<h3>3. Legal Basis for Processing</h3>' +
        '<span class="legal-ref">PDPL ART. 4, ART. 5</span>' +
        '<ul>' +
        '<li><strong>Contract performance:</strong> To process and fulfil orders and manage returns</li>' +
        '<li><strong>Legal obligation:</strong> To comply with Bahraini tax, customs, and commercial laws</li>' +
        '<li><strong>Legitimate interests:</strong> To improve our website, prevent fraud, and maintain security</li>' +
        '<li><strong>Consent:</strong> For marketing emails — you may withdraw at any time</li>' +
        '</ul>' +

        '<h3>4. How We Use Your Data</h3>' +
        '<ul>' +
        '<li>Processing and fulfilling orders and managing delivery</li>' +
        '<li>Sending order confirmations, shipping updates, and customer service communications</li>' +
        '<li>Sending marketing communications where you have given explicit consent</li>' +
        '<li>Improving website functionality and user experience</li>' +
        '<li>Fraud prevention and security monitoring</li>' +
        '<li>Complying with applicable Bahraini laws and regulatory requirements</li>' +
        '</ul>' +

        '<h3>5. Data Sharing & International Transfers</h3>' +
        '<span class="legal-ref">PDPL ART. 26 · PDPA RESOLUTION NO. 42 OF 2022</span>' +
        '<p>We do not sell your personal data. We share data only with trusted service providers for order fulfilment, payment processing, email delivery, and website hosting. Any international transfer is made only to countries on the PDPA Adequacy List (Resolution No. 42 of 2022) or with your explicit consent.</p>' +

        '<h3>6. Data Retention</h3>' +
        '<span class="legal-ref">PDPL ART. 6</span>' +
        '<ul>' +
        '<li>Order and transaction data: 5 years (commercial record-keeping)</li>' +
        '<li>Marketing consent records: Until consent is withdrawn, plus 1 year</li>' +
        '<li>Technical/log data: 12 months</li>' +
        '</ul>' +

        '<h3>7. Your Rights as a Data Subject</h3>' +
        '<span class="legal-ref">PDPL ART. 17, ART. 23</span>' +
        '<div class="legal-highlight"><p>Under the PDPL, you have the right to access, correct, block, or erase your personal data at any time by contacting us at <strong>support@emberparlum.com</strong>.</p></div>' +
        '<ul>' +
        '<li><strong>Right to access:</strong> Request a copy of your personal data</li>' +
        '<li><strong>Right to rectification:</strong> Request correction of inaccurate data</li>' +
        '<li><strong>Right to erasure:</strong> Request deletion where there is no lawful basis to retain it</li>' +
        '<li><strong>Right to block:</strong> Request restriction of processing in certain circumstances</li>' +
        '<li><strong>Right to withdraw consent:</strong> Withdraw marketing consent at any time</li>' +
        '<li><strong>Right to complain:</strong> File a complaint with the PDPA at <strong>www.pdp.gov.bh</strong></li>' +
        '</ul>' +

        '<h3>8. Cookies & Tracking</h3>' +
        '<p>We use cookies to improve your experience and analyse traffic. You may disable cookies through your browser settings; some site functionality may be affected.</p>' +

        '<h3>9. Security</h3>' +
        '<p>We implement appropriate technical and organisational security measures. In the event of a data breach posing risk to your rights, we will notify the PDPA and affected individuals promptly as required by law.</p>' +

        '<h3>10. Changes & Contact</h3>' +
        '<p>This Policy was last updated: <strong>May 2026</strong>. For questions, contact our Data Protection Officer at: <strong>support@emberparlum.com</strong> or write to AlHidd, Manama, Kingdom of Bahrain.</p>'
    },

    terms: {
      eyebrow: 'EMBER · TERMS & CONDITIONS',
      title: 'Terms & Conditions',
      html: '<span class="legal-ref">ELECTRONIC TRANSACTIONS LAW (LEGISLATIVE DECREE NO. 28 OF 2002) · CONSUMER PROTECTION LAW NO. 35 OF 2012 · KINGDOM OF BAHRAIN</span>' +
        '<p>These Terms and Conditions govern your use of the Ember Parfum website and purchase of our products. By placing an order, you agree to be bound by these Terms. Ember Parfum is registered in the Kingdom of Bahrain under CR No. 197815-1.</p>' +

        '<h3>1. About Us</h3>' +
        '<p>Ember Parfum is a fragrance house based in the Kingdom of Bahrain, selling luxury eau de parfum and incense products directly to consumers. All prices are in Bahraini Dinar (BHD) and include applicable VAT where required under Bahraini law.</p>' +

        '<h3>2. Eligibility</h3>' +
        '<p>By placing an order, you confirm you are at least 18 years of age and legally capable of entering into binding contracts under Bahraini law.</p>' +

        '<h3>3. Product Information</h3>' +
        '<span class="legal-ref">CONSUMER PROTECTION LAW ART. 5 — RIGHT TO ACCURATE INFORMATION</span>' +
        '<p>We make every effort to ensure product descriptions, images, and pricing are accurate. Product images are illustrative. We reserve the right to correct errors before order confirmation.</p>' +
        '<ul>' +
        '<li>All fragrances contain alcohol and are for external use only</li>' +
        '<li>Full ingredient lists available upon request at support@emberparlum.com</li>' +
        '<li>Bakhoor products are for use with appropriate charcoal burners — follow all safety instructions</li>' +
        '<li>Keep all products out of reach of children</li>' +
        '</ul>' +

        '<h3>4. Orders & Contract Formation</h3>' +
        '<span class="legal-ref">ELECTRONIC TRANSACTIONS LAW · LEGISLATIVE DECREE NO. 28 OF 2002</span>' +
        '<p>A binding contract is formed only upon our written email confirmation of your order. We reserve the right to decline orders before confirmation due to stock availability or suspected fraud.</p>' +

        '<h3>5. Pricing & Payment</h3>' +
        '<span class="legal-ref">CONSUMER PROTECTION LAW · MINISTERIAL RESOLUTION NO. 109 OF 2015</span>' +
        '<p>All prices are in Bahraini Dinar (BHD). In accordance with Ministerial Resolution No. 109 of 2015, <strong>no additional surcharges are applied for payment by credit or debit card</strong>. VAT, where applicable, is shown clearly before checkout.</p>' +

        '<h3>6. Shipping & Delivery</h3>' +
        '<ul>' +
        '<li>Domestic Bahrain delivery: 2–4 business days</li>' +
        '<li>GCC countries: 3–7 business days</li>' +
        '<li>International: 7–14 business days</li>' +
        '</ul>' +
        '<p>Risk and title pass to you upon delivery to your specified address.</p>' +

        '<h3>7. Returns & Refunds</h3>' +
        '<span class="legal-ref">CONSUMER PROTECTION LAW NO. 35 OF 2012 · MOIC IMPLEMENTING RESOLUTION NO. 14</span>' +
        '<div class="legal-highlight"><p>Under the Bahraini Consumer Protection Law, <strong>you have the right to return a defective or non-conforming product within 15 days of receipt for a full refund or replacement</strong>, free of any additional charges.</p></div>' +
        '<p>We also accept returns of unopened, sealed products in original packaging within <strong>14 days</strong> of receipt. Proof of purchase is required. Opened fragrance or incense products cannot be returned unless defective.</p>' +
        '<p>To initiate a return: <strong>support@emberparlum.com</strong>. Refunds are processed within 7–10 business days.</p>' +
        '<p>Complaints may be filed with the Consumer Protection Directorate, MOIC: <strong>www.moic.gov.bh</strong> · Tel: 17007003.</p>' +

        '<h3>8. Intellectual Property</h3>' +
        '<p>All content — name, logo, Arabic identities, imagery, copy, design — is the intellectual property of Ember Parfum and protected under applicable law. No reproduction without prior written permission.</p>' +

        '<h3>9. Governing Law</h3>' +
        '<p>These Terms are governed by the laws of the Kingdom of Bahrain. Disputes are subject to the exclusive jurisdiction of the courts of the Kingdom of Bahrain. Last updated: <strong>May 2026</strong>.</p>'
    },

    shipping: {
      eyebrow: 'EMBER · SHIPPING & RETURNS',
      title: 'Shipping & Returns',
      html: '<span class="legal-ref">CONSUMER PROTECTION LAW NO. 35 OF 2012 · MOIC RESOLUTION NO. 14</span>' +

        '<h3>Shipping</h3>' +
        '<ul>' +
        '<li><strong>Bahrain (domestic):</strong> 2–4 business days · Flat rate BHD 2.000 / Free over BHD 25</li>' +
        '<li><strong>GCC countries:</strong> 3–7 business days · Calculated at checkout</li>' +
        '<li><strong>International:</strong> 7–14 business days · Calculated at checkout</li>' +
        '</ul>' +
        '<p>Orders placed before 12:00 PM AST on a business day are processed the same day. You will receive a tracking number by email once dispatched.</p>' +

        '<h3>Your Statutory Return Rights</h3>' +
        '<div class="legal-highlight"><p>Under Bahraini Consumer Protection Law, you have the right to <strong>return a defective or non-conforming product within 15 days of receipt</strong> for a full refund or replacement, free of any additional charges. This right cannot be waived.</p></div>' +

        '<h3>Our Returns Policy</h3>' +
        '<ul>' +
        '<li>Return within <strong>14 days</strong> of delivery</li>' +
        '<li>Product must be <strong>unopened, sealed, and unused</strong> in original packaging with all labels</li>' +
        '<li>Original proof of purchase (order confirmation) required</li>' +
        '</ul>' +

        '<h3>Non-Returnable Items</h3>' +
        '<ul>' +
        '<li>Opened or unsealed fragrance bottles</li>' +
        '<li>Opened or partially used bakhoor/incense products</li>' +
        '<li>Products damaged by misuse or improper storage</li>' +
        '<li>Products without original packaging or proof of purchase</li>' +
        '</ul>' +

        '<h3>How to Return</h3>' +
        '<p>Email <strong>support@emberparlum.com</strong> with your order number and reason. We will confirm eligibility and provide instructions within 2 business days.</p>' +

        '<h3>Refunds</h3>' +
        '<p>Refunds are processed to your original payment method within <strong>7–10 business days</strong> of receiving the returned product. For defective items, we cover return shipping costs.</p>' +

        '<h3>Consumer Protection Complaints</h3>' +
        '<ul>' +
        '<li>Website: <strong>www.moic.gov.bh</strong></li>' +
        '<li>Hotline: <strong>17007003</strong></li>' +
        '<li>Address: Bahrain Financial Harbour, Manama, Kingdom of Bahrain</li>' +
        '</ul>'
    }
  };

  window.openLegal = function (type) {
    var doc = LEGAL[type];
    if (!doc) return;
    document.getElementById('legalEyebrow').textContent = doc.eyebrow;
    document.getElementById('legalTitle').textContent   = doc.title;
    document.getElementById('legalBody').innerHTML      = doc.html;
    document.getElementById('legalBody').scrollTop      = 0;
    document.getElementById('legalVeil').classList.add('open');
    document.getElementById('legalModal').classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.closeLegal = function () {
    document.getElementById('legalVeil').classList.remove('open');
    document.getElementById('legalModal').classList.remove('open');
    document.body.style.overflow = '';
  };

  /* ════════════════════════════════════════════════════
     6. EVENT BINDINGS + INIT
  ════════════════════════════════════════════════════ */

  function bindEvents() {
    /* Nav */
    var menuToggle = document.getElementById('menuToggle');
    var menuClose  = document.getElementById('menuClose');
    var menuScrim  = document.getElementById('menuScrim');
    var cartToggle = document.getElementById('cartToggle');
    var cartClose  = document.getElementById('cartClose');
    var cartVeil   = document.getElementById('cartVeil');

    if (menuToggle) menuToggle.addEventListener('click', openMenu);
    if (menuClose)  menuClose.addEventListener('click', closeMenu);
    if (menuScrim)  menuScrim.addEventListener('click', closeMenu);
    if (cartToggle) cartToggle.addEventListener('click', openCart);
    if (cartClose)  cartClose.addEventListener('click', closeCart);
    if (cartVeil)   cartVeil.addEventListener('click', closeCart);

    document.querySelectorAll('.close-menu').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });

    /* Keyboard */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCart();
        closeMenu();
        window.closeLegal();
      }
    });

    /* Scroll */
    window.addEventListener('scroll', function () {
      scrollY = window.scrollY;
      if (!ticking) {
        RAF(onTick);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', function () { vh = window.innerHeight; });
  }

  function init() {
    bindEvents();
    bindAddToCartButtons();
    bindCartPageQty();
    staggerCopyChildren();
    buildParallax();
    buildHeroBottles();
    buildChapters();
    sectionVeils = Array.from(document.querySelectorAll('.hero-bg-veil, .atm-veil'));
    initReveal();
    scrollY = window.scrollY;
    tickParallax();
    tickUI();

    /* Fade in page */
    document.body.classList.add('ready');

    /* Hero entrance */
    setTimeout(function () {
      document.querySelectorAll('.hero-title, .hero-ar, .hero-eyebrow, .hero-sub, .hero-actions, .hero-bottle').forEach(function (el) {
        el.classList.add('in');
      });
    }, 80);

    /* Refresh cart count on load */
    CartAPI.getCart(function (cart) {
      var ct = document.getElementById('cartCt');
      if (ct) ct.textContent = cart.item_count;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
